import React from 'react';
import './Table.css'; // import the above CSS

const Table = ({ 
  columns = [], 
  data = [], 
  className = '',
  tableWrapperStyle={},
  tableStyle={},
  thStyle = {},
  tdStyle = {}
  }) => {
  return (
    <div className={`generic-table-container ${className}`}>
      <div className="generic-table-wrapper" style={{...tableWrapperStyle}}>
        <table className="generic-table" style={{...tableStyle}}>
          <thead className="generic-table-header">
            <tr>
              {columns.map((col) => (
                <th key={col.key} style={{...thStyle}} onClick={col.onClick}>
                  {col.label}
                  {col.icon && <span style={{ marginLeft: '6px' }}>{col.icon}</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '16px' }}>
                  No data available.
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col) => (
                    <td key={col.key} style={{...tdStyle}}>
                      {row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
